export default {
  methods: {
    sendEventGA (category, label, action) {
      this.$ga.event({
        eventCategory: category,
        eventLabel: label,
        eventAction: action ? action : 'Clicked'
      })
    }
  }
}
